import { Swiper, Navigation} from "swiper/bundle";
export default class Swiperinteractive {
    constructor() {
        console.log('%c👍🏼 Swiper Interactive', 'color: yellow');     
        this.swiperinteractive = document.querySelectorAll('.swiper-interactive')
    }
    init() {
        this.swiperinteractive.forEach((module, i) => {

            const elem = module.querySelector('.swiper--interactive')
            const nextButton = module.querySelector('.swiper-button-next')
            const prevButton = module.querySelector('.swiper-button-prev')
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: true,
                spaceBetween: 30,
                speed: 1001,
                allowTouchMove: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    540: {
                    slidesPerView: 1.7
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 60,
                        initialSlide: 2,
                        centeredSlides: true,
                    },
                    998: {
                        slidesPerView: 3.6,
                        spaceBetween: 80
                    },
                }
            });   


            const streches = module.querySelectorAll('button');
            streches.forEach((stretch, i) => {
                stretch.addEventListener( 'click', () => {
                    stretch.classList.toggle('jazzy');
                })
            });

            let shadow = document.querySelector(".cursor-shadow");
            const mouse_shadow = function(event) {
                shadow.style.top = event.pageY - 150  + 'px';
                shadow.style.left = event.pageX - 150 + 'px';
                shadow.style.opacity = 1;
            }
              
            module.addEventListener("mousemove", mouse_shadow)
            module.addEventListener("mouseleave", () => {
                shadow.style.opacity = 0;
            })

            const slides = module.querySelectorAll('.swiper-slide');
            
            slides.forEach((slide) => {

                const draggableImage = slide.querySelector('.swiper-interactive__draggableImage');
                const slideUp = slide.classList.contains('swiper-slide--portrait');

                let isDragging = false;
                let startEvent;

                draggableImage.addEventListener("mousedown", handleDragStart);
                draggableImage.addEventListener("touchstart", handleDragStart, { passive: false });

                slide.addEventListener("mousemove",handleDragMove);
                slide.addEventListener("touchmove", handleDragMove, { passive: false });

                slide.addEventListener("mouseup", handleDragEnd);
                slide.addEventListener("touchend", handleDragEnd);

                function handleDragStart(e) {
                    e.preventDefault();
                    isDragging = true;
                    startEvent = (e.type === 'mousedown') ? e : e.touches[0];
                    draggableImage.style.cursor = "grabbing";
                }

                function handleDragMove(e) {
                    if (!isDragging) return;
                    
                    const currentEvent = (e.type === 'mousemove') ? e : e.touches[0];
                    const deltaY = currentEvent.clientY - startEvent.clientY;
                    const newTop = draggableImage.offsetTop + deltaY;

                    // Ensure the image stays within the vertical bounds
                    const maxY = 130;
                    const minY = -130;

                    if (slideUp) {
                        draggableImage.style.top = `${Math.min(0, Math.max(newTop, minY))}px`;
                    } else {
                        draggableImage.style.top = `${Math.max(0, Math.min(newTop, maxY))}px`;
                    }

                    startEvent = currentEvent;
                }

                function handleDragEnd() {
                    isDragging = false;
                    draggableImage.style.cursor = "grab";
                }
            });
            
            

        })
    }
}